import AmplitudeUtils from '../../utils/amplitude-utils';
import CheckBox, { CheckBoxProps } from './CheckBox';

export default function AutoPushCheckBoxOie(props: Readonly<CheckBoxProps>) {
  return (
    <CheckBox
      doMoreOnChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        if (event?.type === 'change') {
          if (event.target.checked) {
            AmplitudeUtils.logMfaChallengeEvent('OktaVerify::AutoPush::Check');
          }
          else {
            AmplitudeUtils.logMfaChallengeEvent('OktaVerify::AutoPush::Uncheck');
          }
        }
      }}
      {...props}
      className={'fe_u_margin--top-medium'}
    />
  );
}
